import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";

import PlatformModule from "~/store/PlatformModule";

/**
 * A composable/hook that provides the platformStore
 * @returns the current PlatformModule store instance
 */
export default function () {
  const store = useStore();

  return getModule(PlatformModule, store);
}
